import './index.scss';

import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { IdelinkCustomerApp, IdelinkLauncher } from './IdelinkLauncher';
import { EnvironmentHelper } from './libs/IdeLink.Web.Common/src/Helpers/EnvironmentHelper';
import { initSentry } from './libs/IdeLink.Web.Common/src/configs/SentryConfig';

export const appName = EnvironmentHelper.isLocalDev() ? IdelinkCustomerApp.DEMOLINK : '__APP__';

initSentry(appName);

if (process.env.NODE_ENV !== 'production') {
	const whyDidYouRender = await import('@welldone-software/why-did-you-render');
	whyDidYouRender.default(React);
}

const App = IdelinkLauncher.getApp(appName);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
	<React.StrictMode>
		<Suspense fallback={<></>}>
			<App />
		</Suspense>
	</React.StrictMode>
);
